// Used to manage the layout of the version details page with the right side bar component enabled
// with new Progressive Delivery features e.g. launch card, approvers, progress tracking
export const VERSION_DETAIL_PADDING = 24;
export const RIGHT_SIDEBAR_WIDTH: number = 400 + VERSION_DETAIL_PADDING * 2;

// https://hello.atlassian.net/wiki/spaces/CDX/pages/2842038372/LDR+We+will+limit+the+size+of+the+version+description+field
export const VERSION_DESCRIPTION_MAX_NUM_BYTES = 16384;
